<template>
    <div class="nav-container">
        <div class="container">
            <nav class="navbar navbar-expand-lg">
                <a class="navbar-brand" href="https://www.minescape.net/">Minescape</a>
                <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                    <span class="navbar-toggler-icon"></span>
                </button>

                <div class="collapse navbar-collapse" id="navbarSupportedContent">
                    <ul class="navbar-nav mr-auto">
                        <li class="nav-item" v-for="nav in navItems" :key="nav.href">
                            <router-link class="nav-link" :to="nav.href">{{nav.label}}</router-link>
                        </li>
                    </ul>
                </div>
            </nav>
        </div>
    </div>
</template>

<script>
export default {
    data: function() {
        return {
            navItems: [
                {
                    label: "Home",
                    href: "/"
                },
                {
                    label: "Grand Exchange",
                    href: "/ge"
                },
                {
                    label: "Getting started",
                    href: "/getting-started"
                },
                // {
                //     label: "To-Do list",
                //     href: "/todo"
                // }
            ]
        }
    }
}
</script>

<style scoped>
.nav-container {
    background-color: #151515;
    min-height: 60px;
}

    .nav-item > a {
        color: rgba(255, 255, 255, 0.7);
    }

    .nav-item > a:hover {
        text-decoration: none;
    }
</style>